/* Hand-authored Kannada for the common parent-facing UI. English string → Kannada.
 *
 * These are the strings a parent sees constantly (fees, attendance, the feed, the child dashboard),
 * translated by hand so they're instant and correct. Anything NOT here falls back to the server's AI
 * translation (cached), so the app is complete either way — this file just makes the hot path perfect
 * and free. Keys are the exact English source strings used in t('...') call sites. */
export const kn: Record<string, string> = {
  // ---- global / nav ----
  'Overview': 'ಸಾರಾಂಶ',
  'Fees': 'ಶುಲ್ಕ',
  'Attendance': 'ಹಾಜರಾತಿ',
  'Feed': 'ಸುದ್ದಿ',
  'From the school': 'ಶಾಲೆಯಿಂದ',
  'Communication': 'ಸಂವಹನ',
  'News & achievements': 'ಸುದ್ದಿ ಮತ್ತು ಸಾಧನೆಗಳು',
  'School news & achievements': 'ಶಾಲಾ ಸುದ್ದಿ ಮತ್ತು ಸಾಧನೆಗಳು',
  'Notifications': 'ಅಧಿಸೂಚನೆಗಳು',
  'Sign out': 'ಸೈನ್ ಔಟ್',
  'Home': 'ಮುಖಪುಟ',
  'Settings': 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
  'Notifications in': 'ಅಧಿಸೂಚನೆಗಳು ಈ ಭಾಷೆಯಲ್ಲಿ',

  // ---- fees ----
  'Fees due': 'ಬಾಕಿ ಶುಲ್ಕ',
  'Pay fees': 'ಶುಲ್ಕ ಪಾವತಿಸಿ',
  'Pay now': 'ಈಗ ಪಾವತಿಸಿ',
  'Outstanding': 'ಬಾಕಿ',
  'Paid': 'ಪಾವತಿಸಲಾಗಿದೆ',
  'Balance': 'ಶಿಲ್ಕು',
  'Invoice': 'ಸರಕುಪಟ್ಟಿ',
  'Receipt': 'ರಸೀದಿ',
  'Payments': 'ಪಾವತಿಗಳು',
  'All years': 'ಎಲ್ಲಾ ವರ್ಷಗಳು',
  'All fee types': 'ಎಲ್ಲಾ ಶುಲ್ಕ ಪ್ರಕಾರಗಳು',
  'No payments yet': 'ಇನ್ನೂ ಯಾವುದೇ ಪಾವತಿಗಳಿಲ್ಲ',
  'Due': 'ಬಾಕಿ',
  'Due date': 'ಪಾವತಿ ದಿನಾಂಕ',
  'Amount': 'ಮೊತ್ತ',
  'All fees are paid. Nothing outstanding.': 'ಎಲ್ಲಾ ಶುಲ್ಕಗಳು ಪಾವತಿಯಾಗಿವೆ. ಯಾವುದೇ ಬಾಕಿ ಇಲ್ಲ.',

  // ---- attendance ----
  'Present': 'ಹಾಜರಿ',
  'Absent': 'ಗೈರುಹಾಜರಿ',
  'On leave': 'ರಜೆಯಲ್ಲಿ',
  'Late': 'ತಡವಾಗಿ',
  'Today': 'ಇಂದು',
  'This month': 'ಈ ತಿಂಗಳು',
  'Attendance this month': 'ಈ ತಿಂಗಳ ಹಾಜರಾತಿ',

  // ---- child dashboard ----
  'No child linked yet': 'ಇನ್ನೂ ಯಾವುದೇ ಮಗು ಲಿಂಕ್ ಆಗಿಲ್ಲ',
  'Link a child': 'ಮಗುವನ್ನು ಲಿಂಕ್ ಮಾಡಿ',
  'Today’s classes': 'ಇಂದಿನ ತರಗತಿಗಳು',
  'Teacher absent today': 'ಇಂದು ಶಿಕ್ಷಕರು ಗೈರುಹಾಜರಿ',
  'Raise a request': 'ವಿನಂತಿ ಸಲ್ಲಿಸಿ',
  'Awaiting the school’s reply': 'ಶಾಲೆಯ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
  'Stop': 'ನಿಲ್ದಾಣ',
  'Bus': 'ಬಸ್',
  'Your child': 'ನಿಮ್ಮ ಮಗು',

  // ---- feed / news ----
  'Nothing yet': 'ಇನ್ನೂ ಏನೂ ಇಲ್ಲ',
  'Announcements from the school will appear here.': 'ಶಾಲೆಯ ಪ್ರಕಟಣೆಗಳು ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತವೆ.',
  'Show less': 'ಕಡಿಮೆ ತೋರಿಸು',
  'Tap to read more': 'ಹೆಚ್ಚು ಓದಲು ಟ್ಯಾಪ್ ಮಾಡಿ',
  'unread': 'ಓದದ',
  'You have': 'ನಿಮ್ಮಲ್ಲಿ',
  'message': 'ಸಂದೇಶ',
  'messages': 'ಸಂದೇಶಗಳು',

  // ---- common actions / status ----
  'Save': 'ಉಳಿಸಿ',
  'Cancel': 'ರದ್ದುಮಾಡಿ',
  'Close': 'ಮುಚ್ಚಿ',
  'Loading…': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ…',
  'Something went wrong': 'ಏನೋ ತಪ್ಪಾಗಿದೆ',
  'Search': 'ಹುಡುಕಿ',
  'Yes': 'ಹೌದು',
  'No': 'ಇಲ್ಲ',
  'Date': 'ದಿನಾಂಕ',
  'Name': 'ಹೆಸರು',
  'Status': 'ಸ್ಥಿತಿ',
  'Class': 'ತರಗತಿ',

  // ---- parent surface: nav, portal, homework, bus & pickup ----
  'Academics': 'ಶೈಕ್ಷಣಿಕ',
  'Administration': 'ಆಡಳಿತ',
  'Admissions': 'ಪ್ರವೇಶ',
  'Announcements': 'ಪ್ರಕಟಣೆಗಳು',
  'Approvals': 'ಅನುಮೋದನೆಗಳು',
  'Automation': 'ಸ್ವಯಂಚಾಲನೆ',
  'Branding': 'ಬ್ರಾಂಡಿಂಗ್',
  'Bus & pickup': 'ಬಸ್ ಮತ್ತು ಪಿಕಪ್',
  'Cancel this pass': 'ಈ ಪಾಸ್ ರದ್ದುಗೊಳಿಸಿ',
  'Certificates': 'ಪ್ರಮಾಣಪತ್ರಗಳು',
  'Collected': 'ಸ್ವೀಕರಿಸಲಾಗಿದೆ',
  'Collecting': 'ಕರೆದೊಯ್ಯುತ್ತಿರುವವರು',
  'Create a pickup pass': 'ಪಿಕಪ್ ಪಾಸ್ ರಚಿಸಿ',
  'Download': 'ಡೌನ್‌ಲೋಡ್',
  'Downloads': 'ಡೌನ್‌ಲೋಡ್‌ಗಳು',
  'Drop location': 'ಇಳಿಸುವ ಸ್ಥಳ',
  'Eligibility': 'ಅರ್ಹತೆ',
  'Enter the code your school gave you.': 'ನಿಮ್ಮ ಶಾಲೆ ನೀಡಿದ ಕೋಡ್ ನಮೂದಿಸಿ.',
  'Exams': 'ಪರೀಕ್ಷೆಗಳು',
  'Family': 'ಕುಟುಂಬ',
  'Fee admin': 'ಶುಲ್ಕ ನಿರ್ವಹಣೆ',
  'Fee recovery': 'ಶುಲ್ಕ ವಸೂಲಾತಿ',
  'Finance': 'ಹಣಕಾಸು',
  'From': 'ಇಂದ',
  'Grade': 'ಶ್ರೇಣಿ',
  'HR': 'ಮಾನವ ಸಂಪನ್ಮೂಲ',
  'Holidays': 'ರಜಾದಿನಗಳು',
  'Homework': 'ಮನೆಕೆಲಸ',
  'Homework & messages': 'ಮನೆಕೆಲಸ ಮತ್ತು ಸಂದೇಶಗಳು',
  'Hostel': 'ವಸತಿ ನಿಲಯ',
  'Houses & leadership': 'ಸದನ ಮತ್ತು ನಾಯಕತ್ವ',
  'Invoice details': 'ಇನ್‌ವಾಯ್ಸ್ ವಿವರಗಳು',
  'Laboratories': 'ಪ್ರಯೋಗಾಲಯಗಳು',
  'Library': 'ಗ್ರಂಥಾಲಯ',
  'Marks': 'ಅಂಕಗಳು',
  'Max': 'ಗರಿಷ್ಠ',
  'Messages': 'ಸಂದೇಶಗಳು',
  'My classroom': 'ನನ್ನ ತರಗತಿ',
  'My family': 'ನನ್ನ ಕುಟುಂಬ',
  'My leave': 'ನನ್ನ ರಜೆ',
  'My orders': 'ನನ್ನ ಆರ್ಡರ್‌ಗಳು',
  'My school': 'ನನ್ನ ಶಾಲೆ',
  'No files to download yet.': 'ಇನ್ನೂ ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಕಡತಗಳಿಲ್ಲ.',
  'No homework': 'ಮನೆಕೆಲಸ ಇಲ್ಲ',
  'No invoices yet.': 'ಇನ್ನೂ ಇನ್‌ವಾಯ್ಸ್ ಇಲ್ಲ.',
  'No messages': 'ಸಂದೇಶಗಳಿಲ್ಲ',
  'No published results yet.': 'ಇನ್ನೂ ಫಲಿತಾಂಶ ಪ್ರಕಟವಾಗಿಲ್ಲ.',
  'No records yet.': 'ಇನ್ನೂ ದಾಖಲೆಗಳಿಲ್ಲ.',
  'No remarks yet.': 'ಇನ್ನೂ ಟಿಪ್ಪಣಿಗಳಿಲ್ಲ.',
  'No report cards published yet.': 'ಇನ್ನೂ ವರದಿ ಕಾರ್ಡ್ ಪ್ರಕಟವಾಗಿಲ್ಲ.',
  'No requests yet.': 'ಇನ್ನೂ ವಿನಂತಿಗಳಿಲ್ಲ.',
  'No store items allocated yet.': 'ಇನ್ನೂ ಅಂಗಡಿ ವಸ್ತುಗಳನ್ನು ನೀಡಲಾಗಿಲ್ಲ.',
  'No timetable published for this class yet.': 'ಈ ತರಗತಿಗೆ ಇನ್ನೂ ವೇಳಾಪಟ್ಟಿ ಪ್ರಕಟವಾಗಿಲ್ಲ.',
  'No upcoming holidays listed.': 'ಮುಂಬರುವ ರಜಾದಿನಗಳಿಲ್ಲ.',
  'Operations': 'ಕಾರ್ಯಾಚರಣೆ',
  'Order from the school store': 'ಶಾಲಾ ಅಂಗಡಿಯಿಂದ ಆರ್ಡರ್ ಮಾಡಿ',
  'Partly paid': 'ಭಾಗಶಃ ಪಾವತಿ',
  'Payroll': 'ವೇತನ ಪಟ್ಟಿ',
  'People': 'ಸಿಬ್ಬಂದಿ',
  'Pickup pass': 'ಪಿಕಪ್ ಪಾಸ್',
  'Privacy notice': 'ಗೌಪ್ಯತಾ ಸೂಚನೆ',
  'Profile': 'ಪ್ರೊಫೈಲ್',
  'Public page': 'ಸಾರ್ವಜನಿಕ ಪುಟ',
  'Recent days': 'ಇತ್ತೀಚಿನ ದಿನಗಳು',
  'Release requests': 'ಬಿಡುಗಡೆ ವಿನಂತಿಗಳು',
  'Remarks': 'ಟಿಪ್ಪಣಿಗಳು',
  'Report cards': 'ವರದಿ ಕಾರ್ಡ್‌ಗಳು',
  'Requests': 'ವಿನಂತಿಗಳು',
  'Results': 'ಫಲಿತಾಂಶಗಳು',
  'Safety': 'ಸುರಕ್ಷತೆ',
  'School': 'ಶಾಲೆ',
  'School settings': 'ಶಾಲಾ ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
  'Sessions': 'ಅವಧಿಗಳು',
  'Sports': 'ಕ್ರೀಡೆ',
  'Staff attendance': 'ಸಿಬ್ಬಂದಿ ಹಾಜರಾತಿ',
  'Store': 'ಅಂಗಡಿ',
  'Store & allocations': 'ಅಂಗಡಿ ಮತ್ತು ಹಂಚಿಕೆ',
  'Student life': 'ವಿದ್ಯಾರ್ಥಿ ಜೀವನ',
  'Students': 'ವಿದ್ಯಾರ್ಥಿಗಳು',
  'Subject': 'ವಿಷಯ',
  'The bus': 'ಬಸ್',
  'The gate': 'ಗೇಟ್',
  'These conversations are part of the school record.': 'ಈ ಸಂಭಾಷಣೆಗಳು ಶಾಲಾ ದಾಖಲೆಯ ಭಾಗವಾಗಿವೆ.',
  'Timetable': 'ವೇಳಾಪಟ್ಟಿ',
  'Title': 'ಶೀರ್ಷಿಕೆ',
  'Transport': 'ಸಾರಿಗೆ',
  'Valid for': 'ಮಾನ್ಯತೆ',
  'Your requests': 'ನಿಮ್ಮ ವಿನಂತಿಗಳು',

  // ---- school trips ----
  'Trips': 'ಪ್ರವಾಸಗಳು',
  'No trips at the moment.': 'ಸದ್ಯಕ್ಕೆ ಯಾವುದೇ ಪ್ರವಾಸವಿಲ್ಲ.',
  'Going': 'ಹೋಗುತ್ತಿದ್ದಾರೆ',
  'Not going': 'ಹೋಗುತ್ತಿಲ್ಲ',
  'Your reply needed': 'ನಿಮ್ಮ ಉತ್ತರ ಬೇಕು',
  'Withdrawn': 'ಹಿಂಪಡೆಯಲಾಗಿದೆ',
  'The school needs your permission before your child can go on this trip.': 'ನಿಮ್ಮ ಮಗು ಈ ಪ್ರವಾಸಕ್ಕೆ ಹೋಗಲು ಶಾಲೆಗೆ ನಿಮ್ಮ ಅನುಮತಿ ಬೇಕು.',
  'Yes, my child may go': 'ಹೌದು, ನನ್ನ ಮಗು ಹೋಗಬಹುದು',
  'Emergency contact': 'ತುರ್ತು ಸಂಪರ್ಕ',
  'Medical note': 'ವೈದ್ಯಕೀಯ ಟಿಪ್ಪಣಿ',
  'The trip fee is on your Payments page.': 'ಪ್ರವಾಸದ ಶುಲ್ಕ ನಿಮ್ಮ ಪಾವತಿ ಪುಟದಲ್ಲಿದೆ.',
  'Withdraw permission': 'ಅನುಮತಿ ಹಿಂಪಡೆಯಿರಿ',
  'School trips': 'ಶಾಲಾ ಪ್ರವಾಸಗಳು',

  // ---- deliveries ----
  'Your delivery': 'ನಿಮ್ಮ ವಿತರಣೆ',
  'Being packed': 'ಪ್ಯಾಕ್ ಮಾಡಲಾಗುತ್ತಿದೆ',
  'On the way': 'ದಾರಿಯಲ್ಲಿದೆ',
  'Delivered': 'ತಲುಪಿಸಲಾಗಿದೆ',
  'Came back to school': 'ಶಾಲೆಗೆ ಹಿಂತಿರುಗಿದೆ',
  'Sent on': 'ಕಳುಹಿಸಿದ ದಿನಾಂಕ',
  'Delivered on': 'ತಲುಪಿದ ದಿನಾಂಕ',
  'Please contact the school office.': 'ದಯವಿಟ್ಟು ಶಾಲಾ ಕಚೇರಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ.',
  'Track': 'ಜಾಡು ನೋಡಿ',
  'No child is linked to your account yet, so a pickup pass cannot be created. Please ask the school office to link your child.': 'ನಿಮ್ಮ ಖಾತೆಗೆ ಇನ್ನೂ ಯಾವುದೇ ಮಗುವನ್ನು ಜೋಡಿಸಲಾಗಿಲ್ಲ, ಆದ್ದರಿಂದ ಪಿಕಪ್ ಪಾಸ್ ರಚಿಸಲಾಗುವುದಿಲ್ಲ. ದಯವಿಟ್ಟು ಶಾಲಾ ಕಚೇರಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ.',
};
